import { call, put, takeLatest } from 'redux-saga/effects';
import {
    getRegistrySetRequestFiltersSuccess,
    getRegistrySetRequestFiltersError,

    getRegistrySetRequestSuccess,
    getRegistrySetRequestError,

    getRegistrySetRequestCountSuccess,
    getRegistrySetRequestCountError
} from './actions';
import * as url from '../../helpers/url_helper';
import { RegistrySetRequestTypes } from './actionTypes';

let controller = new AbortController();
let signal = controller.signal;

export const cancelFetchRSR = () => {
    controller.abort();
    controller = new AbortController();
    signal = controller.signal;
};

const FormatDynamicFilter = (dynamicFilter: any, newClientId: any) => {
    const clientIdRegex = /clientId: "\d+"/;
    if (clientIdRegex.test(dynamicFilter)) {
        return dynamicFilter.replace(clientIdRegex, `clientId: "${newClientId}"`);
    } else {
        return `${dynamicFilter}, clientId: "${newClientId}"`;
    }
};

export const fetchListRegistrySetRequest = async ({ payload }: any) => {
    const { from, to, order } = payload.filters;
    let { dynamicFilter } = payload.filters;
    const { sizePerPage, page } = payload.pagination;

    const path = url.API_URL;

    let user;

    const getAuthUser = localStorage.getItem('authUser');
    if (getAuthUser) {
        user = JSON.parse(getAuthUser);
    }

    if (user?.ROL_ID != 19) {
        dynamicFilter = FormatDynamicFilter(dynamicFilter, user.EMPRESA_ID);
    }

    const query = `query {
      GetRegistrySetRequest(
        RegistrySetRequest: {
          userId: ${user.id || ''},
        },
        filters: {
          initial_date: "${from || ''}",
          final_date:"${to + ' 11:59:00' || ''}",
          order : "${order}",
          ${dynamicFilter}
        },
        Pagination:{
          sizePage:${sizePerPage}, 
          actualPage:${page}
        }){
          CountItems
          listData {
            id
            clientId
            operationType
            Number
            description
            createdAt
          }
        }
    }`;

    const response = await fetch(path, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            query,
        }),
        signal
    }).then((res) => res.json());

    return response.data.GetRegistrySetRequest;
};

export const RegistrySetRequestFilters = async () => {
    const path = url.API_URL;
    let user;

    const getAuthUser = localStorage.getItem('authUser');
    if (getAuthUser) {
        user = JSON.parse(getAuthUser);
    }

    const query = `query {
      GetRegistrySetRequestFilters(
        rolId: "${user.ROL_ID || ""}"
      ){
        filterItems {
          text
          dataField
          showInFilters
          data {
            id
            name
          }
        }
      }
  }`;

    const response = await fetch(path, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            query,
        }),
        signal
    }).then((res) => res.json());

    return response.data.GetRegistrySetRequestFilters;
};

function* getRegistrySetRequestSaga(payload: any) {
    try {
        const response: Promise<any> = yield call(fetchListRegistrySetRequest, payload);
        if (response) {
            yield put(getRegistrySetRequestSuccess(response));
        }
    } catch (error) {
        yield put(getRegistrySetRequestError(error));
    }
}

function* getRegistrySetRequestFiltersSaga() {
    try {
        const response: Promise<any> = yield call(RegistrySetRequestFilters);
        if (response) {
            yield put(getRegistrySetRequestFiltersSuccess(response));
        }
    } catch (error) {
        yield put(getRegistrySetRequestFiltersError(error));
    }
}

export const RegistrySetRequestCount = async ({ payload }: any) => {
    const { from, to } = payload.filters;
    const path = url.API_URL;
    let user;

    const getAuthUser = localStorage.getItem('authUser');
    if (getAuthUser) {
        user = JSON.parse(getAuthUser);
    }

    const query = `query {
      GetRegistrySetRequestCount(
        RegistrySetRequest: {
          userId: ${user.id || ''},
        },
        filters: {
          initial_date: "${from || ''}",
          final_date:"${to + ' 11:59:00' || ''}",
        }){
          CountItems          
        }
    }`;

    const response = await fetch(path, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            query,
        }),
        signal
    }).then((res) => res.json());

    return response.data.GetRegistrySetRequestCount;
};

function* getRegistrySetRequestCountSaga(payload: any) {
    try {
        const response: Promise<any> = yield call(RegistrySetRequestCount, payload);
        console.log( response )
        if (response) {
            yield put(getRegistrySetRequestCountSuccess(response));
        }
    } catch (error) {
        yield put(getRegistrySetRequestCountError(error));
    }
}

function* RegistrySetRequestSaga() {
    yield takeLatest(RegistrySetRequestTypes.GET_TRANSACTION_LIST, getRegistrySetRequestSaga);
    yield takeLatest(RegistrySetRequestTypes.GET_FILTER_LIST, getRegistrySetRequestFiltersSaga);
    yield takeLatest(RegistrySetRequestTypes.GET_TRANSACTION_COUNT, getRegistrySetRequestCountSaga);
}

export default RegistrySetRequestSaga;
